import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "@/core/components/ui/button";
import { cn } from "@/core/utils/func/cn";

type PageBackButtonProps = {
  /** Chemin de la liste parente (plus fiable que l'historique). */
  to: string;
  /** Libellé visible — i18n côté consommateur (`common.back`). */
  label: string;
  className?: string;
};

/**
 * Bouton de retour vers la liste parente, à placer à gauche du titre
 * d'une page de détail. Inspiré du template AdminCN (`Button` ghost +
 * icône gauche + lien explicite, pas `history.back`).
 */
export function PageBackButton({ to, label, className }: PageBackButtonProps) {
  return (
    <Button
      variant="ghost"
      size="sm"
      className={cn("group shrink-0", className)}
      asChild
    >
      <Link to={to}>
        <ArrowLeft
          className="mr-2 h-4 w-4 transition-transform duration-200 group-hover:-translate-x-0.5"
          aria-hidden
        />
        {label}
      </Link>
    </Button>
  );
}
